import * as React from 'react';
import styles from './Remote.css';
import { Sidebar } from 'components/sidebar';
export const Remote = () => {
    return (React.createElement("div", { id: "app", className: styles.remote },
        React.createElement(Sidebar, { popup: true })));
};
